export * from "ce/actions/tenantActions";
import { ReduxActionTypes } from "ee/constants/ReduxActionConstants";
import type { UpdateCurrentTenantConfigRequest } from "ee/api/TenantApi";

export const updateCurrentTenantConfig = (
  payload: UpdateCurrentTenantConfigRequest,
) => ({
  type: ReduxActionTypes.UPDATE_CURRENT_TENANT_CONFIG,
  payload,
});


export const deleteTenantConfig = () => ({
  type: ReduxActionTypes.DELETE_TENANT_CONFIG,
});